export const FLAG_GETTING_PREVENTIVE_TASK_ASSIGNEES =
  'FLAG_GETTING_PREVENTIVE_TASK_ASSIGNEES';
export const GET_PREVENTIVE_TASK_ASSIGNEES = 'GET_PREVENTIVE_TASK_ASSIGNEES';
export const CLEAR_PREVENTIVE_TASK_ASSIGNEES =
  'CLEAR_PREVENTIVE_TASK_ASSIGNEES';
export const FLAG_PREVENTIVE_TASK_ASSIGNEE_ACTIVITY =
  'FLAG_PREVENTIVE_TASK_ASSIGNEE_ACTIVITY';
export const GET_PREVENTIVE_TASK_ASSIGNEE = 'GET_PREVENTIVE_TASK_ASSIGNEE';
export const CLEAR_PREVENTIVE_TASK_ASSIGNEE = 'CLEAR_PREVENTIVE_TASK_ASSIGNEE';
